// Toast de `copiar-semana` cuando algunas asignaciones caen en un día "No
// opera" del destino (design horario-turno-dia §5, §6). `null` cuando no se
// omitió nada: no hay nada que anunciar.
export function textoOmitidasDiaSinTurno(n: number): string | null {
  if (n <= 0) return null;
  if (n === 1) return 'Se omitió 1 asignación en un día sin turno';
  return `Se omitieron ${n} asignaciones en días sin turno`;
}
